import type { TrustLevel } from '@/api/types';

const ICONS: Record<TrustLevel, string> = {
  SHADOWBAN: '🚫',
  NEWBIE: '⚠️',
  TRUSTED: '🛡',
  ELITE: '👑',
};

interface Props {
  level: TrustLevel;
  levelLabel: string;
  score: number;
}

export function TrustScoreBadge({ level, levelLabel, score }: Props) {
  return (
    <div className={`trust-badge ${level.toLowerCase()}`}>
      <div className="icon" aria-hidden>{ICONS[level]}</div>
      <div className="meta">
        <div className="title">{levelLabel} · {score}%</div>
        <div className="sub">{describe(level)}</div>
      </div>
    </div>
  );
}

function describe(level: TrustLevel): string {
  switch (level) {
    case 'ELITE':     return 'x1.2 к оплате, моментальные выплаты';
    case 'TRUSTED':   return 'Автоподтверждение, доступ к аналитике';
    case 'NEWBIE':    return 'Выплаты заморожены на 24ч';
    case 'SHADOWBAN': return 'Загружай только свои свежие скриншоты';
  }
}
